import { render, staticRenderFns } from "./select-cms-provider.vue?vue&type=template&id=f78808e4&scoped=true&"
import script from "./select-cms-provider.vue?vue&type=script&lang=js&"
export * from "./select-cms-provider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78808e4",
  null
  
)

export default component.exports